export default {
    store: undefined,

    install: function(Vue, options) {
        this.store = options.store;

        Vue.prototype.__ = word => this.store.getters.getTranslation(word);
    }
};